import { Structure } from '../structure/structure';
import { SafeUrl } from '@angular/platform-browser';
import { MmModel } from '@docma-mm-core/model/mm.model';
import { MmSyncableModel } from '@docma-mm-core/model/mm-syncable.model';
import { BehaviorSubject } from 'rxjs';
import { User } from '@docma-mm-core/user/user';
import { DocumentType } from '@docma-mm-core/document-type/document-type';
import { AttachmentType } from './attachment-type';

export class AttachmentData {

  constructor(init?: Partial<AttachmentData>) {
    if (init) {
     Object.assign(this, init);
     if (init.Date) {
      this.Date = new Date(init.Date);
     }
     if (init.CreatedOn) {
      this.CreatedOn = new Date(init.CreatedOn);
     }
     if (init.ModifiedOn) {
      this.ModifiedOn = new Date(init.ModifiedOn);
     }
    }
  }

  Structure?: Structure;
  Id?: number;
  UniqueId?: string;
  SUid?: string;
  Size?: number;
  MimeType?: string;
  FileName?: string;
  Description?: string;
  Comment?: string;
  Date?: Date;
  Type?: AttachmentType;
  VisibleFor?: number;
  EditableFor?: number;
  IsFaultAttachment?: boolean ;
  IsActivityAttachment?: boolean ;
  DocumentType?: DocumentType;
  Creator?: User;
  Modifier?: User;
  CreatedOn?: Date;
  ModifiedOn?: Date;
  OriginalFileName?: string;
}

export class AttachmentSource extends MmModel<File> {
  constructor(init?: Partial<AttachmentSource>) {
    super(init);
    if (init) {
      this.url = init.url;
      this.name = init.name;
    }
  }
  url: string | SafeUrl;
  name: string;
}

export class Attachment extends MmSyncableModel<AttachmentData> {

  private _thumbnail = new BehaviorSubject<AttachmentSource>(new AttachmentSource());
  public thumbnail$ = this._thumbnail.asObservable();

  private _source = new BehaviorSubject<AttachmentSource>(new AttachmentSource());
  public source$ = this._source.asObservable();

  isPdf?: boolean;
  isOtherType?: boolean;

  fault: {id?: number, uid?: string};
  activity: {id?: number, uid?: string};




  constructor(init?: Partial<Attachment>) {
    super(init);
    if (init) {
      if (init.source) {
        this.source = new AttachmentSource(init.source);
      }
    }
    if (!this.source) {
      this.source = new AttachmentSource();
    }
    if (!this.thumbnail) {
      this.thumbnail = new AttachmentSource();
    }

  }

  get isNew(): boolean {
    return !this.id;
  }

  get thumbnail(): AttachmentSource {
    return this._thumbnail.value;
  }

  set thumbnail(v: AttachmentSource) {
    this._thumbnail.next(v);
  }

  get source(): AttachmentSource {
    return this._source.value;
  }

  set source(v: AttachmentSource) {
    this._source.next(v);
  }

  static getDataFromFile(file: File): AttachmentData {
    const ad = new AttachmentData();
    ad.Date = file.lastModified ? new Date(file.lastModified): null ;
    ad.MimeType = file.type;
    ad.FileName = file.name;
    ad.Size = file.size;
    return ad;
  }



}


